export default __webpack_public_path__ + "static/media/Icon-Caution.3197b772.svg";